import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { createAdditionalAdjustment, updateAdditionalAdjustment, getSchoolAdjustments } from 'actions/additional_adjustments';
import { Editor } from 'UI/Inputs';
import { Button } from '@haldor/ui';

var CreateAdditionalAdjustmentForm = /*#__PURE__*/function (_Component) {
  _inherits(CreateAdditionalAdjustmentForm, _Component);

  var _super = _createSuper(CreateAdditionalAdjustmentForm);

  function CreateAdditionalAdjustmentForm(props) {
    var _this;

    _classCallCheck(this, CreateAdditionalAdjustmentForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onTitleChange", function (event) {
      _this.setState({
        title: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubTitleChange", function (event) {
      _this.setState({
        subTitle: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDescriptionChange", function (event) {
      _this.setState({
        description: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (values) {
      var onClose = _this.props.onClose;
      return new Promise(function (resolve) {
        if (_this.props.initialValues == null) {
          _this.props.createAdditionalAdjustment(values).then(function () {
            resolve(1);

            if (onClose) {
              onClose();
            }
          });
        } else {
          _this.props.updateAdditionalAdjustment(values).then(function () {
            _this.props.getSchoolAdjustments().then(function () {
              resolve(1);

              if (onClose) {
                onClose();
              }
            });
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          margintop: '1rem',
          color: 'red'
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          margintop: '1rem',
          color: 'red'
        }
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value != 'undefined' && value != '' && value != null) {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate('field-max-200-chars');
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _this.state = {
      title: '',
      subTitle: '',
      description: ''
    };
    return _this;
  }

  _createClass(CreateAdditionalAdjustmentForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit,
          valid = _this$props.valid;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.onSubmit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row textarea"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('title'), " *"), /*#__PURE__*/React.createElement(Field, {
        component: this.renderInput,
        type: "text",
        name: "title",
        validate: this.required,
        placeholder: this.props.translate('title')
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row textarea"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('description')), /*#__PURE__*/React.createElement(Field, {
        component: Editor,
        name: "description",
        placeholder: this.props.translate('description'),
        translate: this.props.translate
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row submit spacing"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid
      }, this.props.translate('save')), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))));
    }
  }]);

  return CreateAdditionalAdjustmentForm;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    translate: translate(state.Languages.translations),
    initialValues: ownProps.editAdjustment
  };
}

export default connect(mapStateToProps, {
  createAdditionalAdjustment: createAdditionalAdjustment,
  updateAdditionalAdjustment: updateAdditionalAdjustment,
  getSchoolAdjustments: getSchoolAdjustments
})(reduxForm({
  form: 'CreateAdditionalAdjustmentForm',
  destroyOnUnmount: true
})(CreateAdditionalAdjustmentForm));